
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34318',
  depVersions: {
  "documents-public-ui": "static-1.34318",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34323",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2055",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5520",
  "hs-test-utils": "static-1.7939",
  "hub-http": "static-1.6146",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11386",
  "I18n": "static-7.1606",
  "jasmine-immutable": "static-1.2944",
  "jasmine-runner": "static-1.6394",
  "lodash": "static-1.3",
  "quartz": "static-1.6912",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16585",
  "reporting-data": "static-1.67168",
  "reporting-testing-lib": "static-1.9101",
  "reporting-visualizations": "static-1.59244",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4695",
  "webpack-env": "static-1.54",
  "atom": "static-1.4996",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2419",
  "classnames": "static-2.10",
  "cssUtils": "static-1.773",
  "customer-data-filters-ui": "static-1.39483",
  "customer-data-objects": "static-1.7587",
  "customer-data-property-utils": "static-1.8009",
  "data-fetching-client": "static-1.9600",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4454",
  "flux-actions": "static-1.326",
  "FormsCommonComponents": "static-1.85639",
  "FormUrlGenerator": "static-2.4645",
  "foundations-components": "static-1.7785",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11694",
  "icons": "static-2.640",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7084",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3774",
  "property-translator": "static-1.5329",
  "quartz-config": "static-1.690",
  "quartz-core": "static-1.6131",
  "quick-fetch": "static-1.3858",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5284",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8094",
  "reference-resolvers-lite": "static-1.8017",
  "report-customization-components": "static-1.12904",
  "reporting-enablement": "static-1.22614",
  "reporting-reports": "static-1.66846",
  "reporting-snowflake": "static-1.55786",
  "reporting-ui-components": "static-2.64439",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4570",
  "sales-content-partitioning": "static-1.8862",
  "SalesContentIndexUI": "static-3.9128",
  "sanitize": "static-1.4398",
  "sanitize-text": "static-1.8070",
  "self-service-api": "static-1.10171",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1673",
  "signup-constants": "static-1.18717",
  "signup-ui-lego-core": "static-1.20727",
  "signup-ui-url-generator": "static-2.7959",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4694",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10916",
  "ui-addon-i18n": "static-1.11076",
  "ui-addon-react-router-dom": "static-1.9470",
  "ui-addon-upgrades": "static-9.17877",
  "ui-asset-management-lib": "static-1.10920",
  "ui-images": "static-2.1133",
  "UIComponents": "static-3.8333",
  "usage-tracker": "static-1.7262",
  "usage-tracker-container": "static-1.7252",
  "usage-tracker-core": "static-1.7112",
  "usage-tracker-public": "static-1.7073",
  "viral-links-lib": "static-1.6975",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3343",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3189",
  "quartz-webpack": "static-1.3136",
  "ai-components-ui-library": "static-1.8752",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4778",
  "foundations-theming": "static-1.4339",
  "quartz-auth": "static-1.587",
  "ui-business-units-lib": "static-1.8968",
  "usage-tracker-session-replay": "static-1.4948",
  "foundations-theming-base": "static-1.3324",
  "HeadJS": "static-2.737",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3050",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.24",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4250",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7851",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3531",
  "persist-promise": "static-1.3635",
  "quartz-i18n": "static-1.587",
  "reporting-client-types": "static-1.2443",
  "foundations-components-legacy": "static-1.810",
  "hs-story-utils": "static-1.9355",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9790",
  "hubspotter-http": "static-1.4592",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7175",
  "crm-message-bus": "static-1.42776",
  "customer-data-filters-ui-msw-helpers": "static-1.21918",
  "customer-data-objects-ui-components": "static-1.12946",
  "customer-data-reference-ui-components": "static-1.13080",
  "customer-data-ui-utilities": "static-1.9752",
  "framework-builder-read-service-client": "static-1.3950",
  "framework-data-schema-quick-fetch": "static-1.6706",
  "framework-data-schema-resolvers": "static-1.6801",
  "inbound-db-properties-service-client": "static-1.3782",
  "multi-account-reference-resolvers": "static-1.901",
  "onboarding-tours": "static-1.16460",
  "reporting-datasets-permissions-lib": "static-1.13450",
  "ui-addon-teams": "static-1.21448",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68125",
  "customer-data-properties": "static-1.51277",
  "forms-ai-lib": "static-1.4198",
  "forms-utils-lib": "static-1.12439",
  "foundations-components-test-utils": "static-1.5268",
  "react-dnd-compat": "static-1.4545",
  "react-tinymce": "static-1.55024",
  "tinymce-config": "static-2.54150",
  "ui-gdpr-components": "static-1.10273",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4054",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1602",
  "ui-fonts": "static-1.648",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.822",
  "mobile-manifest-mixins": "static-1.511",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.577",
  "quartz-routing": "static-1.342",
  "quartz-test": "static-1.587",
  "quartz-tracking": "static-1.291",
  "batch-promise": "static-1.1478",
  "external-options-client-types": "static-1.4099",
  "react-colorpicker": "static-2.10135",
  "copilot-toolkit": "static-1.10925",
  "data-quality-ui-library": "static-1.12680",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6390",
  "reporting-action-components": "static-1.41089",
  "reporting-filters": "static-1.123",
  "reporting-insights-lib": "static-1.1501",
  "reporting-plugins": "static-1.10173",
  "ui-addon-draggable-compat": "static-2.4180",
  "ui-addon-opt": "static-4.8306",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25139",
  "hubspot-apollo-client": "static-1.4803",
  "chirp-fetch": "static-1.1808",
  "sales-templates-service-types-lib": "static-1.4108",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5737",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4018",
  "nested-table": "static-1.152",
  "timezone-utils": "static-2.5169",
  "bender-build-tools": "static-1.3093",
  "chatspot-core": "static-1.20942",
  "bend-plugin-foundations-theming": "static-1.2822",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9788",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3737",
  "crm-pipelines-api-client-types": "static-1.4083",
  "multi-currency-client-types": "static-1.3632",
  "getting-started-shared-tasks": "static-1.18283",
  "growth-data-modal": "static-1.5310",
  "growth-onboarding-confetti": "static-1.2995",
  "growth-onboarding-next-action-utils": "static-1.1691",
  "navigation-components": "static-1.17766",
  "onboarding-tours-client": "static-1.4674",
  "onboarding-tours-utils": "static-1.526",
  "ui-shepherd-react": "static-3.10074",
  "ui-shepherd-tracker": "static-1.7455",
  "ui-universal-auth": "static-1.8881",
  "user-context": "static-1.5026",
  "cms-field-types": "static-1.4735",
  "content-icons-ui": "static-1.2206",
  "integrations-lib": "static-1.15867",
  "calling-global-api": "static-1.64203",
  "calling-internal-common": "static-1.31227",
  "calling-lifecycle-internal": "static-1.65585",
  "calling-lifecycle-messages": "static-1.57879",
  "commerce-products-lib": "static-1.9239",
  "crm-links": "static-1.6205",
  "customer-data-properties-shared-msw-handlers": "static-1.9117",
  "file-manager-components": "static-1.23384",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.66",
  "inbounddb-objects-service-types": "static-1.4164",
  "meetings-icalendar-utils-lib": "static-1.556",
  "object-builder-ui-client": "static-1.48483",
  "pipeline-validation-client-types": "static-1.3906",
  "property-value-citations": "static-1.1891",
  "pulse": "static-1.472",
  "smart-property-lib": "static-1.6549",
  "tiered-pricing": "static-1.1051",
  "ui-addon-iframeable": "static-1.8977",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19702",
  "tinymce-themes": "static-1.56120",
  "data-token-picker": "static-1.16273",
  "hub-http-contrib": "static-1.2967",
  "interframe": "static-3.4688",
  "tinymce-data": "static-1.40235",
  "tinymce-plugins": "static-1.57264",
  "ui-addon-sales-email": "static-1.5137",
  "magpie-lib": "static-1.5514",
  "magpie-types": "static-1.4974",
  "simple-logging-lib": "static-1.2976",
  "content-assistance-lib": "static-1.7639",
  "dashboard-lib": "static-1.81222",
  "ExportDialog": "static-6.10317",
  "hubspot-prosemirror": "static-1.18021",
  "hubspot-prosemirror-plugins": "static-1.18013",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8622",
  "campaign-roi-lib": "static-1.8761",
  "feedback-loader": "static-1.29161",
  "apollo-link-hub-http": "static-2.4576",
  "hubspot-apollo-cache": "static-1.262",
  "nav-client-types": "static-1.2283",
  "purchase-motions-api": "static-1.5740",
  "trials-service-types": "static-1.3827",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.99",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1833",
  "growth-onboarding-next-action-components": "static-1.1719",
  "user-context-client": "static-1.4537",
  "idb-keyval": "static-1.42",
  "nest": "static-1.149",
  "reactive-lib": "static-1.648",
  "unified-auth-core-lib": "static-1.676",
  "getting-started-shared-tasks-store": "static-1.17401",
  "integrations-error-boundary-lib": "static-1.13282",
  "integrations-tracking-lib": "static-1.5522",
  "native-integrations-shared-strings": "static-1.7711",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10299",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.395",
  "calling-error-reporting": "static-1.31233",
  "shared-worker-versioning": "static-1.10963",
  "calling-usage-tracker": "static-1.6466",
  "voice-sms-access-library": "static-1.691",
  "customer-data-tracking": "static-1.6810",
  "commerce-permissions": "static-1.691",
  "products-iframe-lib": "static-1.7714",
  "products-ui-components-shared-msw-handlers": "static-1.10172",
  "location-customization-utils-lib": "static-1.9011",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4078",
  "video-components-external": "static-1.11035",
  "video-data-lib": "static-1.34693",
  "directed-graph": "static-1.863",
  "event-emitter": "static-1.873",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.74",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9873",
  "fsm": "static-1.3659",
  "policy-lib": "static-1.6709",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9936",
  "navigation-messaging": "static-1.7093",
  "FileManagerLib": "static-1.39024",
  "NamespacedHubStyle": "static-2.9005",
  "FileManagerCore": "static-1.38883",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12299",
  "layout-dnd-utils": "static-1.11274",
  "react-codemirror": "static-1.10549",
  "ui-addon-emoji-picker": "static-1.9812",
  "ui-brand-identity-lib": "static-1.14911",
  "ui-addon-video-player": "static-1.8622",
  "ui-coaching-tips": "static-1.28330",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8472",
  "payment-link-components": "static-1.23315",
  "EmailSignatureEditor": "static-1.24210",
  "InboxConnectUtils": "static-4.14597",
  "universal-page-editor-lib": "static-1.2934",
  "google-sheets-integration-lib": "static-1.13",
  "microsoft-drive-integration-lib": "static-1.104",
  "calling-orchestration-schema": "static-1.35468",
  "sales-views-client-types": "static-1.4188",
  "crm-record-cards-service-types": "static-1.3551",
  "content-media-composition-data-lib": "static-1.12006",
  "content-media-compositions": "static-2.16013",
  "media-bridge-lib": "static-1.18796",
  "trellis-story-utils": "static-1.4443",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5802",
  "FileManagerImages": "static-1.36535",
  "video-components": "static-1.13038",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4457",
  "video-embed": "static-1.35527",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68200",
  "layout-data-lib": "static-1.9599",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6508",
  "commerce-tours-lib": "static-1.5957",
  "growth-onboarding-reliability": "static-1.5009",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21541",
  "sales-email-signature-service-client": "static-1.3768",
  "social-insights-client-types": "static-1.21860",
  "outpost": "static-1.4116",
  "advanced-menus-core": "static-1.15012",
  "advanced-menus-lib": "static-1.11967",
  "ui-memberships-settings-lib": "static-1.33833",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15011",
  "simple-menus-lib": "static-1.16528"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34318",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34323",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2055",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5520",
  "hs-test-utils": "/hs-test-utils/static-1.7939",
  "hub-http": "/hub-http/static-1.6146",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11386",
  "I18n": "/I18n/static-7.1606",
  "jasmine-immutable": "/jasmine-immutable/static-1.2944",
  "jasmine-runner": "/jasmine-runner/static-1.6394",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6912",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16585",
  "reporting-data": "/reporting-data/static-1.67168",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9101",
  "reporting-visualizations": "/reporting-visualizations/static-1.59244",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4695",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4996",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2419",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.773",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39483",
  "customer-data-objects": "/customer-data-objects/static-1.7587",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8009",
  "data-fetching-client": "/data-fetching-client/static-1.9600",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4454",
  "flux-actions": "/flux-actions/static-1.326",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85639",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4645",
  "foundations-components": "/foundations-components/static-1.7785",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11694",
  "icons": "/icons/static-2.640",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7084",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3774",
  "property-translator": "/property-translator/static-1.5329",
  "quartz-config": "/quartz-config/static-1.690",
  "quartz-core": "/quartz-core/static-1.6131",
  "quick-fetch": "/quick-fetch/static-1.3858",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5284",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8094",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8017",
  "report-customization-components": "/report-customization-components/static-1.12904",
  "reporting-enablement": "/reporting-enablement/static-1.22614",
  "reporting-reports": "/reporting-reports/static-1.66846",
  "reporting-snowflake": "/reporting-snowflake/static-1.55786",
  "reporting-ui-components": "/reporting-ui-components/static-2.64439",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4570",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8862",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9128",
  "sanitize": "/sanitize/static-1.4398",
  "sanitize-text": "/sanitize-text/static-1.8070",
  "self-service-api": "/self-service-api/static-1.10171",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1673",
  "signup-constants": "/signup-constants/static-1.18717",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20727",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7959",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4694",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10916",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11076",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9470",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17877",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10920",
  "ui-images": "/ui-images/static-2.1133",
  "UIComponents": "/UIComponents/static-3.8333",
  "usage-tracker": "/usage-tracker/static-1.7262",
  "usage-tracker-container": "/usage-tracker-container/static-1.7252",
  "usage-tracker-core": "/usage-tracker-core/static-1.7112",
  "usage-tracker-public": "/usage-tracker-public/static-1.7073",
  "viral-links-lib": "/viral-links-lib/static-1.6975",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3343",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3189",
  "quartz-webpack": "/quartz-webpack/static-1.3136",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8752",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4778",
  "foundations-theming": "/foundations-theming/static-1.4339",
  "quartz-auth": "/quartz-auth/static-1.587",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8968",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4948",
  "foundations-theming-base": "/foundations-theming-base/static-1.3324",
  "HeadJS": "/HeadJS/static-2.737",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3050",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.24",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4250",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7851",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3531",
  "persist-promise": "/persist-promise/static-1.3635",
  "quartz-i18n": "/quartz-i18n/static-1.587",
  "reporting-client-types": "/reporting-client-types/static-1.2443",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.810",
  "hs-story-utils": "/hs-story-utils/static-1.9355",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9790",
  "hubspotter-http": "/hubspotter-http/static-1.4592",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7175",
  "crm-message-bus": "/crm-message-bus/static-1.42776",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21918",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12946",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13080",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9752",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3950",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6706",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6801",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3782",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.901",
  "onboarding-tours": "/onboarding-tours/static-1.16460",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13450",
  "ui-addon-teams": "/ui-addon-teams/static-1.21448",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68125",
  "customer-data-properties": "/customer-data-properties/static-1.51277",
  "forms-ai-lib": "/forms-ai-lib/static-1.4198",
  "forms-utils-lib": "/forms-utils-lib/static-1.12439",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5268",
  "react-dnd-compat": "/react-dnd-compat/static-1.4545",
  "react-tinymce": "/react-tinymce/static-1.55024",
  "tinymce-config": "/tinymce-config/static-2.54150",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10273",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4054",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1602",
  "ui-fonts": "/ui-fonts/static-1.648",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.822",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.511",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.577",
  "quartz-routing": "/quartz-routing/static-1.342",
  "quartz-test": "/quartz-test/static-1.587",
  "quartz-tracking": "/quartz-tracking/static-1.291",
  "batch-promise": "/batch-promise/static-1.1478",
  "external-options-client-types": "/external-options-client-types/static-1.4099",
  "react-colorpicker": "/react-colorpicker/static-2.10135",
  "copilot-toolkit": "/copilot-toolkit/static-1.10925",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12680",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6390",
  "reporting-action-components": "/reporting-action-components/static-1.41089",
  "reporting-filters": "/reporting-filters/static-1.123",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1501",
  "reporting-plugins": "/reporting-plugins/static-1.10173",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4180",
  "ui-addon-opt": "/ui-addon-opt/static-4.8306",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25139",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4803",
  "chirp-fetch": "/chirp-fetch/static-1.1808",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4108",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5737",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4018",
  "nested-table": "/nested-table/static-1.152",
  "timezone-utils": "/timezone-utils/static-2.5169",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chatspot-core": "/chatspot-core/static-1.20942",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2822",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9788",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3737",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4083",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3632",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18283",
  "growth-data-modal": "/growth-data-modal/static-1.5310",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2995",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1691",
  "navigation-components": "/navigation-components/static-1.17766",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4674",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.526",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10074",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7455",
  "ui-universal-auth": "/ui-universal-auth/static-1.8881",
  "user-context": "/user-context/static-1.5026",
  "cms-field-types": "/cms-field-types/static-1.4735",
  "content-icons-ui": "/content-icons-ui/static-1.2206",
  "integrations-lib": "/integrations-lib/static-1.15867",
  "calling-global-api": "/calling-global-api/static-1.64203",
  "calling-internal-common": "/calling-internal-common/static-1.31227",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65585",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57879",
  "commerce-products-lib": "/commerce-products-lib/static-1.9239",
  "crm-links": "/crm-links/static-1.6205",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9117",
  "file-manager-components": "/file-manager-components/static-1.23384",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.66",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4164",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.556",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48483",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3906",
  "property-value-citations": "/property-value-citations/static-1.1891",
  "pulse": "/pulse/static-1.472",
  "smart-property-lib": "/smart-property-lib/static-1.6549",
  "tiered-pricing": "/tiered-pricing/static-1.1051",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8977",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19702",
  "tinymce-themes": "/tinymce-themes/static-1.56120",
  "data-token-picker": "/data-token-picker/static-1.16273",
  "hub-http-contrib": "/hub-http-contrib/static-1.2967",
  "interframe": "/interframe/static-3.4688",
  "tinymce-data": "/tinymce-data/static-1.40235",
  "tinymce-plugins": "/tinymce-plugins/static-1.57264",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5137",
  "magpie-lib": "/magpie-lib/static-1.5514",
  "magpie-types": "/magpie-types/static-1.4974",
  "simple-logging-lib": "/simple-logging-lib/static-1.2976",
  "content-assistance-lib": "/content-assistance-lib/static-1.7639",
  "dashboard-lib": "/dashboard-lib/static-1.81222",
  "ExportDialog": "/ExportDialog/static-6.10317",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18021",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18013",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8622",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8761",
  "feedback-loader": "/feedback-loader/static-1.29161",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4576",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.262",
  "nav-client-types": "/nav-client-types/static-1.2283",
  "purchase-motions-api": "/purchase-motions-api/static-1.5740",
  "trials-service-types": "/trials-service-types/static-1.3827",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.99",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1833",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1719",
  "user-context-client": "/user-context-client/static-1.4537",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.149",
  "reactive-lib": "/reactive-lib/static-1.648",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.676",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17401",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13282",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5522",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7711",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10299",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.395",
  "calling-error-reporting": "/calling-error-reporting/static-1.31233",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10963",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6466",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.691",
  "customer-data-tracking": "/customer-data-tracking/static-1.6810",
  "commerce-permissions": "/commerce-permissions/static-1.691",
  "products-iframe-lib": "/products-iframe-lib/static-1.7714",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10172",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9011",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4078",
  "video-components-external": "/video-components-external/static-1.11035",
  "video-data-lib": "/video-data-lib/static-1.34693",
  "directed-graph": "/directed-graph/static-1.863",
  "event-emitter": "/event-emitter/static-1.873",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.74",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9873",
  "fsm": "/fsm/static-1.3659",
  "policy-lib": "/policy-lib/static-1.6709",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9936",
  "navigation-messaging": "/navigation-messaging/static-1.7093",
  "FileManagerLib": "/FileManagerLib/static-1.39024",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9005",
  "FileManagerCore": "/FileManagerCore/static-1.38883",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12299",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11274",
  "react-codemirror": "/react-codemirror/static-1.10549",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9812",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14911",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8622",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28330",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8472",
  "payment-link-components": "/payment-link-components/static-1.23315",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24210",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14597",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2934",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.13",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.104",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35468",
  "sales-views-client-types": "/sales-views-client-types/static-1.4188",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3551",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12006",
  "content-media-compositions": "/content-media-compositions/static-2.16013",
  "media-bridge-lib": "/media-bridge-lib/static-1.18796",
  "trellis-story-utils": "/trellis-story-utils/static-1.4443",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5802",
  "FileManagerImages": "/FileManagerImages/static-1.36535",
  "video-components": "/video-components/static-1.13038",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4457",
  "video-embed": "/video-embed/static-1.35527",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68200",
  "layout-data-lib": "/layout-data-lib/static-1.9599",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6508",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5957",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5009",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21541",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3768",
  "social-insights-client-types": "/social-insights-client-types/static-1.21860",
  "outpost": "/outpost/static-1.4116",
  "advanced-menus-core": "/advanced-menus-core/static-1.15012",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11967",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33833",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15011",
  "simple-menus-lib": "/simple-menus-lib/static-1.16528"
}
};
